import { render, staticRenderFns } from "./gl-section-block.vue?vue&type=template&id=29fae894"
import script from "./gl-section-block.vue?vue&type=script&lang=js"
export * from "./gl-section-block.vue?vue&type=script&lang=js"
import style0 from "./gl-section-block.vue?vue&type=style&index=0&id=29fae894&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports